import { 
  statusDiplomStart,
  statusDiplomSuccess,
  statusDiplomFailure 
} from "./diplomSlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getDiplomsApi = (doctorId: string = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDiplomStart())
    let response
    if(doctorId) {
      response = await get(`diplom?doctor=${doctorId}`)
    } else {
      response = await get(`diplom`)
    }
    const resData = response.data.success
    if(resData) {
      dispatch(statusDiplomSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDiplomFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDiplomFailure(errData))
      return [errData]
    }
  }
}

export const AddDiplomApi = (data: any, doctorId: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDiplomStart())
    let response
    if(doctorId) {
      response = await post(`diplom?doctor=${doctorId}`, data);
    } else {
      response = await post(`diplom`, data);
    }
    const resData = response.data.success
    if(resData) {
      dispatch(statusDiplomSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDiplomFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDiplomFailure(errData))
      return [errData]
    }
  }
}

export const EditDiplomApi = (diplomId: string, data: any, doctorId: any = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDiplomStart())
    let response
    if(doctorId) {
      response = await put(`diplom/${diplomId}?doctor=${doctorId}`, data);
    } else {
      response = await put(`diplom/${diplomId}`, data);
    }
    const resData = response.data.success
    if(resData) {
      dispatch(statusDiplomSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDiplomFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDiplomFailure(errData))
      return [errData]
    }
  }
}

export const DeleteDiplomApi = (diplomId: string, doctorId: any = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusDiplomStart())
    let response
    if(doctorId) {
      response = await remove(`diplom/${diplomId}?doctor=${doctorId}`);
    } else {
      response = await remove(`diplom/${diplomId}`);
    }
    const resData = response.data.success
    if(resData) {
      dispatch(statusDiplomSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusDiplomFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusDiplomFailure(errData))
      return [errData]
    }
  }
}


export const clearDiplomApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusDiplomSuccess([]))
}
